<template>
  <div :class="[containerClass, cellClass]">
    <slot></slot>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop } from "vue-facing-decorator";
import { PropOptions } from "vue";

@Component({ name: "cat-cell" })
export default class CatCell extends Vue {
  @Prop({
    type: [String, Array],
    default: null,
    description:
      "One of or array of: auto, grow, shrink, left, right, top, bottom, middle, center"
  } as PropOptions<any>)
  readonly align?: string | object;
  @Prop({
    type: [Number, String],
    default: "auto",
    description: "Number from 1-12 or 'auto', 'grow', or 'shrink'"
  } as PropOptions<any>)
  readonly cols?: number | string;
  @Prop({
    type: [String],
    default: null,
    description: "class for the cell"
  } as PropOptions<any>)
  readonly cellClass?: string;

  get size(): number | string {
    let result = this.cols || 0;

    if (this.cols && this.cols.toString().indexOf("-") > -1) {
      const arr = this.cols.toString().split("-");
      if (arr.length >= 2) {
        result = arr[1];
      }
    }

    if (result !== "auto" && result !== "grow" && result !== "shrink") {
      result = Number(result);
    }
    return result;
  }

  get screenSize(): string {
    let result = "medium";

    if (this.cols && this.cols.toString().indexOf("-") > -1) {
      const arr = this.cols.toString().split("-");
      if (arr.length >= 2) {
        result = arr[0];
      }
    }
    return result;
  }

  get containerClass(): object {
    var self = this;
    var classes = {
      "cat-cell cell": true,
      "small-12": this.screenSize !== "small",
      [this.screenSize + "-" + this.size]: this.size > 0,
      [this.screenSize + "-auto"]: this.size === "auto",
      [this.screenSize + "-grow"]: this.size === "grow",
      [this.screenSize + "-shrink"]: this.size === "shrink"
    };

    if (Array.isArray(this.align) && this.align.length > 0) {
      this.align.forEach(function (item, index) {
        if (self.align && self.align[index]) {
          classes["flex-align-self-" + self.align[index]] =
            self.align[index] !== null;
        }
      });
    } else {
      classes["flex-align-self-" + this.align] =
        this.align !== null && this.align !== "";
    }

    return classes;
  }
}
</script>
